/**
 * Button loading state utility
 * 
 * Usage:
 * import { setButtonLoading, resetButtonLoading } from './utils-loading.js';
 * 
 * setButtonLoading($btn);
 * resetButtonLoading($btn);
 */

/**
 * Set button to loading state
 * @param {jQuery} $btn 
 */
export const setButtonLoading = ($btn) => {
    $btn.prop('disabled', true);
    $btn.data('original-text', $btn.html());
    $btn.html('<span class="mi-spinner"></span>');
};

/**
 * Reset button to original state
 * @param {jQuery} $btn 
 */
export const resetButtonLoading = ($btn) => {
    $btn.prop('disabled', false);
    $btn.html($btn.data('original-text'));
};